var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { getAccountIdFromStorage } from 'helpers/customBranding';
import BaseMicroservices from './base';
export class Microservices extends BaseMicroservices {
    constructor() {
        super();
        this.accountId = getAccountIdFromStorage();
    }
    uploadFile(file, userId, folder = 'questions') {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const filePath = `${this.accountId}/${folder}/${userId}/${file.name}`;
                const { data: response } = yield this.axios.post('/getPresignedUrl', {
                    method: 'putObject',
                    policy: 'public',
                    filePath,
                });
                yield axios.put(response.url.presignedUrl, file, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                return {
                    name: file.name,
                    url: response.url.fileUrl,
                };
            }
            catch (err) {
                return undefined;
            }
        });
    }
    getDateTime() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.axios.get('/datetime', {});
                return data.datetime ? new Date(data.datetime) : new Date();
            }
            catch (err) {
                return new Date();
            }
        });
    }
}
